import { DocumentationOperationType } from './operationPreflight';

export function isArchiveOperation(operationType: DocumentationOperationType): boolean {
  return operationType === DocumentationOperationType.archive;
}

export function isRestoreOperation(operationType: DocumentationOperationType): boolean {
  return operationType === DocumentationOperationType.restore;
}
